// extracted by mini-css-extract-plugin
module.exports = {"header":"header_header__JVgkB","headerRevealOnScroll":"header_headerRevealOnScroll__6mGeN","header_title":"header_header_title__CDVBp"};